import { ShieldAlert } from "lucide-react";

export default function Disclaimer() {
  return (
    <div
      data-testid="medical-disclaimer"
      className="bg-zinc-900 text-zinc-100 text-xs sm:text-sm px-4 py-2.5 flex items-start gap-2.5"
    >
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0 text-yellow-400" />
      <p className="leading-relaxed">
        <span className="font-semibold">Clinical decision support — for qualified clinician use.</span>{" "}
        Outputs reference Harrison's Principles of Internal Medicine (22e), NEJM, BMJ &amp; JAMA — and the
        Nelson Textbook of Pediatrics for patients aged 5–14 — and are advisory only. This tool does not replace professional medical judgment, examination or
        patient-specific care.
      </p>
    </div>
  );
}
